/**
 * Created by USER on 18/9/19.
 */
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {Input, Checkbox, message, Icon} from 'antd';
import {sha256} from 'js-sha256';
import AffiliateModal from '../component/affiliates_TC';
import httpClient from '../swagger/affiliate_swagger';
import {changeBarState} from '../redux/actions/headerbar_action';
import ImgList from '../images/img';


const { client } = httpClient;

class Alliance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agreementModal: false,
      emailErrorDisplay: 'none', //邮箱的错误提示
      addressErrorDisplay: 'none', //比特币地址的错误提示
      account: '',
      accountErrorDisplay: 'none',
      inputValue: {
        email: '',
        address: ''
      },
      agreeChecked: false,
      robotVerification: false,
      nc_token: null, // 机器人验证的值
      session_id: null, // 机器人验证的值
      sig: null,
      emailErrorText: this.props.t('error_email'),
      addressErrorText: this.props.t('error_address'),
      accountErrorText: this.props.t('error_login_code'),
      accountPlaceholder: '',
      loginWay: 'code'
    }
  }

  componentWillMount() {
    this.props.dispatch(changeBarState('affiliates'));
    const search = this.props.location.search.split('=')[1];
    this.setState({
      accountPlaceholder: search ? search : ''
    });
    if (search !== '' && search !== undefined) { // 判断url是否带入用户id 执行登录
      this.login(search);
    }
  }

  componentDidMount() {
    const {accountPlaceholder} = this.state;
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);
    if (accountPlaceholder === '' || accountPlaceholder === undefined) {
      this.getMemberInfo();
    }
    document.addEventListener('mousedown', (e) => { // 监听机器人验证的滑动
      this.wrapperChange(e, true)
    });
    document.addEventListener('mouseup', (e) => { // 监听机器人验证的滑动
      this.wrapperChange(e, false)
    })
    // this.allianceValidation();
  }

  wrapperChange(e, isChange) { // 人机验证自定义样式的改变
    const ele = document.getElementsByClassName('btn_slide');
    if (e.target == ele[0]) {
      const backgroundEle = document.getElementsByClassName('nc-lang-cnt');
      backgroundEle[0].style.background = 'none';
      backgroundEle[0].style.webkitTextFillColor = isChange ? '#FFF' : "#4d4d4d";
    }
  }

  getMemberInfo() { //获取用户的信息
    client.then((oclient) => {
      oclient.apis.member.get_member_info({}).then((result) => {
        if (result.obj.code === 200) {
          this.props.history.push(`/affiliates/${result.obj.data.code}`);
        }else {
          this.allianceValidation(this.props.t('language') === 'zh' ? 'cn' : 'en');
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => message.error(this.props.t('request_error')));
  }

  allianceValidation() { //初始化机器人验证
    const ncToken = ['FFFF0N00000000005FC2', (new Date()).getTime(), Math.random()].join(':'); // 初始化人机器验证
    if (this.browser() === 'h5') { // 判断页面是否为h5 页面 初始化不同的人机验证
      const nc = window.NoCaptcha.init({ // h5 验证
        renderTo: '#alliance_register_validation',
        appkey: 'FFFF0N00000000005FC2',
        scene: 'nc_login_h5',
        token: ncToken,
        trans: {key1: 'code0'},
        elementID: ['usernameID'],
        is_Opt: 0,
        language: 'cn',
        timeout: 3000,
        retryTimes: 5,
        errorTimes: 5,
        inline: false,
        apimap: {},
        bannerHidden: false,
        initHidden: false,
        callback: (data) => {
          this.setState({
            robotVerification: true,
            nc_token: ncToken,
            session_id: data.csessionid,
            sig: data.sig
          })
        },
      });
      window.NoCaptcha.setEnabled(true);
      nc.reset(); // 请务必确保这里调用一次reset()方法
      window.NoCaptcha.upLang('cn', {
        LOADING: this.props.t('captch8'), // 加载
        SLIDER_LABEL: this.props.t('captcha'), // 等待滑动
        CHECK_Y: this.props.t('captcha1'), // 通过
        ERROR_TITLE: this.props.t('captcha9'), // 拦截
        CHECK_N: this.props.t('catpcha5'), // 准备唤醒二次验证
        OVERLAY_INFORM: this.props.t('captcha10'), // 二次验证
        TIPS_TITLE: this.props.t('captcha11') // 验证码输错时的提示
      });
      // nc.reload();
    } else {
      const ncOpt = // pc－web验证
        {
          renderTo: '#alliance_register_validation',
          appkey: 'FFFF0N00000000005FC2',
          scene: 'nc_login',
          token: ncToken,
          customWidth: 300,
          trans: {key1: 'code0'},
          elementID: ['usernameID'],
          is_Opt: 0,
          language: 'cn',
          isEnabled: true,
          timeout: 3000,
          times: 5,
          apimap: {},
          callback: (data) => {
            this.setState({
              robotVerification: true,
              nc_token: ncToken,
              session_id: data.csessionid,
              sig: data.sig
            })
          }
        };
      const nc = new window.noCaptcha(ncOpt);
      nc.upLang('cn',{
        _startTEXT: this.props.t('captcha'),
        _yesTEXT: this.props.t('captcha1'),
        _error300: `${this.props.t('captcha2')}<a href=\'javascript:__nc.reset()\'>${this.props.t('captcha3')}</a>${this.props.t('captcha4')}`,
        _errorNetwork: `${this.props.t('captcha6')}<a href=\'javascript:__nc.reset()\'>${this.props.t('captcha7')}</a>`,
      });
      nc.reload();
    }
  }

  browser() { // 判断客户端是pc还是移动端
    if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
      return 'h5';
    }
    return 'pc';
  }

  showAgreementModal() { // 联盟协议的modal'
    this.setState({
      agreementModal: true
    });
  }

  handleCancel() { // modal的隐藏函数
    this.setState({
      agreementModal: false
    });
  }

  agreeChecked(e) { // 是否同意协议
    this.setState({
      agreeChecked: e.target.checked
    });
  }

  register() { // 注册会员
    const {agreeChecked, robotVerification, inputValue} = this.state;
    if (agreeChecked && robotVerification) {
      const emailReg = /^(\w)+(\.?\w+)@(\w)+((\.\w{2,3}){1,3})$/;
      const addressReg= /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$/;
      const email = emailReg.test(inputValue.email.replace(/^\s+|\s+$/g, ''));
      const address = addressReg.test(inputValue.address.replace(/^\s+|\s+$/g, ''));
      if (email) { // 表单是否通过
        this.setState({
          updateText: this.props.t('submit_loading')
        });
        const {nc_token, session_id, sig} = this.state;
        client.then((oclient) => { // 请求注册接口
          oclient.apis.member.post_member_register({
            email: inputValue.email,
            nc_token,
            session_id,
            sig
          }).then((result) => {
            if (result.obj.code === 200) {
              this.loginFun(result.obj.data.security_code)
            } else if(result.obj.code === -13102) {
              this.setState({
                emailErrorDisplay: 'block',
                emailErrorText: result.obj.message
              })
            } else {
              message.error(result.obj.message);
            }
          }).catch(() => message.error(this.props.t('request_error')));
        }).catch(() => message.error(this.props.t('request_error')));
      } else {
        if (!email) {
          this.setState({
            emailErrorDisplay: 'block',
            emailErrorText: this.props.t('error_email')
          })
        }
        if (!address) {
          this.setState({
            addressErrorDisplay: 'block',
            addressErrorText: this.props.t('error_address')
          })
        }
      }
    }
  }

  login(account) { // 点击登录按钮
    this.loginFun(account);
  }

  loginFun(account) { // 登录的方法
    client.then((oclient) => {
      oclient.apis.member.post_member_login_in({
        'security_code': account
      }).then((result) => {
        if (result.obj.code === 200) {
          this.props.history.push(`/affiliates/${result.obj.data.code}`);
        }else {
          this.getMemberInfo();
          this.setState({
            accountErrorDisplay: 'block',
            accountErrorText: result.obj.message
          })
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => message.error(this.props.t('request_error')));
  }

  emailOnchange(e) { // 邮箱表单的onchange事件
    const {inputValue} = this.state;
    this.setState({
      emailErrorDisplay:'none',
      inputValue: {
        email: e.target.value,
        address: inputValue.address
      }
    })
  }

  addressOnchange(e) { // BTC 地址的onchange事件
    const {inputValue} = this.state;
    this.setState({
      addressErrorDisplay: 'none',
      inputValue: {
        email: inputValue.email,
        address: e.target.value
      }
    })
  }

  accountOnchange(e) { // 登录账号的onChange事件
    this.setState({
      accountErrorDisplay: 'none',
      account: e.target.value
    })
  }

  changeAffiliateWay() { // 切换登录方式
    const {loginWay} = this.state;
    if(loginWay === 'code') {
      this.setState({
        loginWay: 'qrcode'

      });
      let csrf = [(new Date()).getTime(), 'NJKJ9CYHLDM3AZBRCU', Math.random()].join('');
      let state = sha256(sha256.digest(csrf)).slice(0, 32);

      document.cookie = `csrf=${csrf}; domain=lubanso.com;`;

      const obj = new WxLogin({ // 初始化微信二维码登录
        self_redirect:true,
        id: "affiliate_way",
        appid: "wxd09a3b10289ddf98",
        scope: "snsapi_login",
        redirect_uri: "https://api.lubanso.com:8300/member/wx_login_in",
        state: state,
        style: "",
        href: ""
      });
    } else {
      this.setState({
        loginWay: 'code'
      });
      const affiliateWay = document.getElementById('affiliate_way');
      affiliateWay.innerHTML = '';
    }
  }

  componentWillReceiveProps(nextProps){
    if (this.props.appBarReducer.language !== nextProps.appBarReducer.language) {
      this.allianceValidation(nextProps.appBarReducer.language === 'zh' ? 'cn' : 'en');
    }
  }

  render() {
    const { t } = this.props;
    const {agreementModal, emailErrorDisplay, addressErrorDisplay, agreeChecked, robotVerification,
      accountErrorDisplay, emailErrorText, addressErrorText, accountErrorText, accountPlaceholder, account,
      loginWay
    } = this.state;
    return (
      <div className="alliance">
        <div className="alliance_banner">
          <div>
            <h3>LUBANSO {t('head_affiliate')}</h3>
            <p>{t('affiliate_login_register_notice1')}</p>
          </div>
          <img src={ImgList.img.allianceBanner} alt="lubanso" />
        </div>
        <div
          className="alliance_register_login"
          style={{
            background: `url(${ImgList.img.allianceBackground}) no-repeat`,
            backgroundSize: 'cover'
          }}
        >
          <div>
            <h2>{t('affiliate_login_register')}</h2>
            <span className="alliance_register_login_notice">{t('affiliate_login_register_notice2')}</span>
            <div className="alliance_register">
              {
                loginWay === 'code' ?
                  <div>
                    <h3>{t('affiliate_login')}</h3>
                    <span
                      className="input_error"
                      style={{display: accountErrorDisplay}}
                    >
                      {accountErrorText}
                    </span>
                    <Input
                      placeholder={t('affiliate_login_code')}
                      style={{borderColor: accountErrorDisplay === 'none' ? '#d9d9d9' : '#e4393c' }}
                      onChange={(e) => this.accountOnchange(e)}
                      defaultValue={accountPlaceholder}
                    />
                    <span
                      className="submit"
                      onClick={() => this.login(account)}
                    >{t('affiliate_login_button')}</span>
                  </div> : false

              }
              <div id="affiliate_way" style={{height: loginWay === 'code' ? '0' : '350px'}}></div>
              <p
                className="affiliate_way"
                onClick={() => this.changeAffiliateWay()}
              >
                {loginWay === 'code' ? t('affiliate_login_by_wechat') : t('affiliate_login_by_code')}
                <Icon type="right" />
              </p>
            </div>
          </div>
          <div className="alliance_login">
            <h3>{t('affiliate_register')}</h3>
            <span
              className="input_error"
              style={{display: emailErrorDisplay}}
            >
              {emailErrorText}
            </span>
            <Input
              placeholder={t('affiliate_register_email')}
              style={{borderColor: emailErrorDisplay === 'none' ? '#d9d9d9' : '#e4393c' }}
              onChange={(e) => this.emailOnchange(e)}
            />
            <div
              id="alliance_register_validation"
              className="validation nc-container"
              onChange={() => this.validationChange()}
            />
            <div className="mobile_sumit_order_header">
              <Checkbox onChange={e => this.agreeChecked(e)} />{t('affiliate_register_agreement1')}
              <span
                className="mobile_use_term"
                onClick={() => this.showAgreementModal()}
                onKeyPress={() => this.showAgreementModal()}
              >{t('affiliate_register_agreement2')}</span>{t('affiliate_register_agreement3')}
            </div>
            <span
              onClick={() => this.register()}
              className="submit"
              style={{background: agreeChecked && robotVerification ? '#0085ff' : '#EEEEEE',
                color: agreeChecked && robotVerification ? '#FFFFFF' : 'rgba(0, 0, 0, 0.6)'
              }}
            >{t('affiliate_step_register')}</span>
          </div>
        </div>
        <AffiliateModal
          show={agreementModal}
          handleCancel={() => this.handleCancel()}
          t={t}
        />
        <div className="alliance_features">
          <div>
            <b className="divider_right" />
            <i className="icon iconfont icon-icon-6" />
            <h3>{t('affiliate_step_register')}</h3>
            <p>{t('affiliate_step_register_notice')}</p>
          </div>
          <div>
            <b className="divider_right" />
            <b className="divider_left"/>
            <i className="icon iconfont icon-icon-2" />
            <h3>{t('affiliate_step_set')}</h3>
            <p>{t('affiliate_step_set_notice')}</p>
          </div>
          <div>
            <b className="divider_left"/>
            <i className="icon iconfont icon-icon-" />
            <h3>{t('affiliate_step_commission')}</h3>
            <p>{t('affiliate_step_commission_notice')}</p>
          </div>
        </div>
        <div className="alliance_wechat">
          <div className="alliance_wechat_introduce">
            <h3>{t('affiliate_wechat')}</h3>
            <div><i className="icon iconfont icon-lianmeng-" /><span>{t('affiliate_wechat_notice')}</span></div>
            <div><i className="icon iconfont icon-xiaochengxu-7" /><span>{t('affiliate_wechat_notice1')}</span></div>
            <div><i className="icon iconfont icon-icon-7" /><span>{t('affiliate_wechat_notice2')}</span></div>
            <div><i className="icon iconfont icon-icon-11" /><span>{t('affiliate_wechat_notice3')}</span></div>
          </div>
          <div className="alliance_wechat_img">
            <img src={ImgList.img.allianceWechat} alt="lubanso"/>
          </div>
        </div>
        <div className="alliance_feature">
          <div>
            <div className="single_app_feature">
              <div><i className="icon iconfont icon-lianmengyihuifu-2" /></div>
              <div className="single_app_feature_content">
                <span>{t('affiliate_advantage_1x1')}</span>
                <span>{t('affiliate_advantage_1x1_notice')}</span>
              </div>
            </div>
            <div className="single_app_feature">
              <div><i className="icon iconfont icon-lianmengyihuifu-" /></div>
              <div className="single_app_feature_content">
                <span>{t('affiliate_advantage_1x2')}</span>
                <span>{t('affiliate_advantage_1x2_notice')}</span>
              </div>
            </div>
          </div>
          <div>
            <div className="single_app_feature">
              <div><i className="icon iconfont icon-lianmengyihuifu-3" /></div>
              <div className="single_app_feature_content">
                <span>{t('affiliate_advantage_2x1')}</span>
                <span>{t('affiliate_advantage_2x1_notice')}</span>
              </div>
            </div>
            <div className="single_app_feature">
              <div><i className="icon iconfont icon-lianmengyihuifu-1" /></div>
              <div className="single_app_feature_content">
                <span>{t('affiliate_advantage_2x2')}</span>
                <span>{t('affiliate_advantage_2x2_notice')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


function select(state) {
  return {
    appBarReducer: state.appBarReducer
  };
}

const AllianceConnected = connect(select)(Alliance);

export default translate('translations')(AllianceConnected);
